import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";

export const componentStyles = css.global`
  .live-board-screen {
    backdrop-filter: blur(10px);
    display: flex;
    width: 100%;
    height: 100%;

    .live-board-close {
      position: absolute;
      top: 16px;
      left: 16px;
      cursor: pointer;
    }

    .close-icon {
      margin-right: 12px;
      margin-top: 8px;
      width: 25px;
      height: 20px;
    }

    .live-board-content-wrapper {
      width: 90%;
      height: 90%;
      margin-left: 10%;
      margin-top: 10%;
      display: flex;
      justify-content: center;
      background: ${Colors[WHITE_COLOR_NAME]};
      .live-board-content {
        width: 100%;
      }
    }
  }
`;
